import { gameCheckpointStorage, isGameRoute } from './game-top-up.js';
type Storage = Pick<globalThis.Storage, 'getItem' | 'setItem' | 'removeItem'>;
const requestKey = (userId: string, path: string): string | null => {
  const url = new URL(path, 'https://game.invalid');
  if (
    !path.startsWith('/') ||
    path.startsWith('//') ||
    url.origin !== 'https://game.invalid' ||
    !isGameRoute(url.pathname)
  )
    return null;
  if (url.pathname.startsWith('/path/game/'))
    return `bb:path-checkpoint:${userId}:${url.pathname.split('/').at(-1)}:request`;
  return `bb_run_request_${url.pathname.split('/').at(-1)}_${url.searchParams.get('code') ?? ''}`;
};
export const rememberGameInviteReturn = (
  userId: string,
  path: string,
  storage: Storage = gameCheckpointStorage,
): void => {
  try {
    const key = requestKey(userId, path);
    const requestId = key ? storage.getItem(key) : null;
    if (requestId)
      storage.setItem(
        `bb:game-invite-return:${userId}`,
        JSON.stringify({ path, requestId, at: Date.now() }),
      );
  } catch {
    /* Keep the live game usable if storage is unavailable. */
  }
};
/** Resume only a still-existing attempt, not a completed game or an unrelated launch link. */
export const consumeGameInviteReturn = (
  userId: string,
  storage: Storage = gameCheckpointStorage,
): string | null => {
  try {
    const key = `bb:game-invite-return:${userId}`;
    const saved: unknown = JSON.parse(storage.getItem(key) ?? 'null');
    storage.removeItem(key);
    if (
      !saved ||
      typeof saved !== 'object' ||
      !('path' in saved) ||
      typeof saved.path !== 'string' ||
      !('at' in saved) ||
      typeof saved.at !== 'number' ||
      !('requestId' in saved) ||
      typeof saved.requestId !== 'string'
    )
      return null;
    const checkpoint = requestKey(userId, saved.path);
    const age = Date.now() - saved.at;
    return checkpoint &&
      age >= 0 &&
      age < 3 * 3_600_000 &&
      storage.getItem(checkpoint) === saved.requestId
      ? saved.path
      : null;
  } catch {
    return null;
  }
};
